module.exports = __webpack_public_path__ + "img/1_002.3a00d2e5.jpg";